import React, { useState, useImperativeHandle, forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import styled from 'styled-components';
import 'react-datepicker/dist/react-datepicker.css';
import { colorText, colorAccent, colorFieldsBorder } from '@/utils/palette';
import { CalendarBlankIcon } from '@/shared/dynamicImports';
import { formatDate } from './utils';
import { DatePickerWrap } from './DatePickerElements';

const DateIntervalPickerField = forwardRef(
  (
    {
      name,
      label = 'Select Date Range',
      defaultRange,
      onChange,
      error,
      dateOutputFormat = 'format3',
      helperText,
      isClearable = true,
    },
    ref,
  ) => {
    const [startDate, setStartDate] = useState(convertToCorrectInputFormat(defaultRange?.start) || null);
    const [endDate, setEndDate] = useState(convertToCorrectInputFormat(defaultRange?.end) || null);
    const [calendarOpen, setCalendarOpen] = useState(false);

    function convertToCorrectInputFormat(dateString) {
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        // If in YYYY-MM-DD format, append "T08:00"
        return `${dateString}T08:00`; // Append "T08:00"
      } else {
        return dateString;
      }
    }

    const handleChange = (dates) => {
      const [start, end] = dates;
      setStartDate(start);
      setEndDate(end);
      let formattedStart = formatDate(start, dateOutputFormat);
      let formattedEnd = formatDate(end, dateOutputFormat);

      onChange({ start: formattedStart, end: formattedEnd });
    };

    const handleCalendarIconClick = () => {
      setCalendarOpen((prevState) => !prevState);
    };

    const handleDatePickerClick = () => {
      setCalendarOpen(true);
    };

    const clearDates = () => {
      setStartDate(null);
      setEndDate(null);
      setCalendarOpen(false);
    };

    useImperativeHandle(ref, () => ({
      clearDates,
    }));

    return (
      <div>
        {label && <Label error={error}>{label}</Label>}
        <div style={{ display: 'flex' }}>
          <DatePickerWrap>
            <StyledDatePicker
              selected={startDate}
              onChange={handleChange}
              selectsRange
              startDate={startDate}
              endDate={endDate}
              dateFormat='MM/dd/yyyy'
              open={calendarOpen}
              onClickOutside={() => setCalendarOpen(false)}
              onClick={handleDatePickerClick}
              onFocus={handleDatePickerClick}
              placeholderTextStart='Start Date'
              placeholderTextEnd='End Date'
              isClearable={isClearable}
            />
          </DatePickerWrap>

          <StyledCalendarIcon onClick={handleCalendarIconClick}>
            <CalendarBlankIcon />
          </StyledCalendarIcon>
        </div>
        {helperText && <HelperText>{helperText}</HelperText>}
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </div>
    );
  },
);

DateIntervalPickerField.displayName = 'DateIntervalPickerField';

export default DateIntervalPickerField;

// Styled components
const Label = styled.div`
  font-size: 12px;
  margin-top: 5px;
  color: ${(props) => (props.error ? 'red' : colorText)};
`;

const ErrorMessage = styled.div`
  color: red;
  margin-bottom: 20px;
  font-size: 12px;
`;

const HelperText = styled.div`
  font-size: 12px;
  margin-top: 5px;
  color: ${colorText};
`;

const StyledCalendarIcon = styled.div`
  cursor: pointer;
  font-size: 16px;
  color: #6c757d;
  border: 1px solid ${colorFieldsBorder};
  border-radius: 2px;
  height: 32px;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 16px;
    height: 16px;
  }
`;

// const Label = styled.div`
//   color: ${colorText};
//   font-size: 12px;
// `;

const StyledDatePicker = styled(DatePicker)`
  outline: none;
  // width: 100%;
  // height: 28px;
  padding: 5px 12px;
  font-size: 12px;
  border: 1px solid ${colorFieldsBorder};
  border-radius: 2px;
  background-color: transparent !important;
  color: ${colorText};

  // &:focus {
  //   outline: none;
  //   border-color: ${colorAccent} !important;
  // }

  // &::placeholder {
  //   color: #999;
  // }

  // .react-datepicker__input-container {
  //   width: 100%;
  // }

  // .react-datepicker__day--selected,
  // .react-datepicker__day--keyboard-selected {
  //   background-color: ${colorAccent} !important;
  //   color: #fff;
  // }

  // .react-datepicker__header {
  //   background-color: #f8f9fa;
  //   border-bottom: 1px solid #e9ecef;
  // }

  // .react-datepicker__day {
  //   &:hover {
  //     background-color: ${colorAccent} !important;
  //     color: #fff;
  //   }
  }

  // .react-datepicker__close-icon {
  //   background-color: transparent;
  //   &:after {
  //     background-color: ${colorAccent} !important;
  //     color: white;
  //     border-radius: 50%;
  //   }
  // }
`;
